import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export default function TrailerModal({ videoUrl, onClose }) {
  useEffect(() => {
    if (!videoUrl) return undefined;
    const onKey = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [videoUrl, onClose]);

  if (!videoUrl) return null;

  return (
    <div
      className="trailer-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="trailer-modal-content"
        onClick={e => e.stopPropagation()}
      >
        <button
          type="button"
          className="trailer-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <video
          key={videoUrl}
          src={videoUrl}
          autoPlay
          controls
          playsInline
          className="trailer-modal-video"
        />
      </div>
    </div>
  );
}

TrailerModal.propTypes = {
  videoUrl: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

TrailerModal.defaultProps = {
  videoUrl: null,
};
